import React from "react";
import { useTranslation } from "react-i18next";

interface ThinkingBubbleProps {
  theme?: {
    iconColor: string;
  };
}

export const ThinkingBubble: React.FC<ThinkingBubbleProps> = ({ theme }) => {
  const { t } = useTranslation("polls");
  return (
    <div className="flex gap-3 justify-start animate-in fade-in slide-in-from-bottom-2 duration-300">
      <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center">
        <svg
          className={`w-6 h-6 ${theme?.iconColor || "text-blue-500"} animate-pulse`}
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
        </svg>
      </div>
      <div className="bg-[#3c4043]/30 text-gray-400 rounded-[20px] px-5 py-3 flex items-center gap-2">
        <span className="text-sm font-medium">{t("chat.thinking")}</span>
        <div className="flex gap-1">
          <span className="w-1 h-1 bg-gray-400 rounded-full animate-bounce [animation-delay:-0.3s]"></span>
          <span className="w-1 h-1 bg-gray-400 rounded-full animate-bounce [animation-delay:-0.15s]"></span>
          <span className="w-1 h-1 bg-gray-400 rounded-full animate-bounce"></span>
        </div>
      </div>
    </div>
  );
};
